DialogController = App.loadClass 'core::Angular/DialogController'

class exports.SurveyDetailsDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance, @repo, survey_result, field) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Survey Details'

        @scope.placeholder = 'Loading survey details...'
        @scope.left_column = {}
        @scope.right_column = {}
        @scope.isArray = (value) -> value instanceof Array

        @loadSurveyDetails(survey_result, field)

    loadSurveyDetails: (survey_result, field) =>
        @repo.getSurveyDetails(survey_result, field).then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.setAlert(result.data?.status)
                else
                    @scope.setAlert
                        type: 'error'
                        msg: 'Failed to load details for this survey'
                return

            results = result.data.data.results
            @balanceColumns(results)

        , () =>
            # if the request failed
            @scope.setAlert
                type: 'error'
                msg: 'Failed to load details for this survey'

    balanceColumns: (details) =>
        # adapted from Grower/viewmodels/placement/seed_options/Field.coffee
        @scope.left_column = {}
        @scope.right_column = {}

        if not details?.length
            return

        total_height = 0
        for detail in details
            [key, value] = detail
            total_height += if value instanceof Array then 3 else 1

        # This is where the column-balancing magic happens.

        # Single details will be placed in the right column only once the left
        # column takes up at least half the combined height of the columns.
        # Multiselect details will be moved to the right column more often,
        # such that they may even cause the right column to be taller than the
        # left, which is sometimes preferable (hence the `total_height - 4`).
        # This also enables us to place a multiselect in the right column,
        # while keeping a later single detail in the left column.
        # This results in a generally well-balanced output, with the
        # multiselects mostly in the right column.
        # Please do not change this without consulting me first.
        # -SK

        left_height = 0
        # right_height = 0
        for detail in details
            [key, value] = detail
            is_array = value instanceof Array
            if not is_array and left_height < total_height / 2
                @scope.left_column[key] = value
                left_height += 1
            else if is_array and left_height < (total_height - 4) / 2
                @scope.left_column[key] = value
                left_height += 3
            else
                @scope.right_column[key] = value
